import bannerStrandRight from "../assets/images/banner-strand-right.png"

export const invoicePay = {
    invoicePayTextBody: {
          "data":{
          },
          "content":[
            {
              "data":{
      
              },
              "content":[
                {
                  "data":{
      
                  },
                  "marks":[
      
                  ],
                  "value":"At Moderna, we strive to provide our customers with a seamless and convenient payment experience.",
                  "nodeType":"text"
                }
              ],
              "nodeType":"paragraph"
            },
            {
              "data":{
      
              },
              "content":[
                {
                  "data":{
      
                  },
                  "marks":[
      
                  ],
                  "value":"",
                  "nodeType":"text"
                }
              ],
              "nodeType":"paragraph"
            },
            {
              "data":{
      
              },
              "content":[
                {
                  "data":{
      
                  },
                  "marks":[
      
                  ],
                  "value":"Currently, we accept:",
                  "nodeType":"text"
                }
              ],
              "nodeType":"paragraph"
            },
            {
              "data":{
      
              },
              "content":[
                {
                  "data":{
      
                  },
                  "marks":[
                    {
                      "type":"bold"
                    }
                  ],
                  "value":"Credit Card, ACH Bank Transfer, Bank Wire Transfer and Check",
                  "nodeType":"text"
                }
              ],
              "nodeType":"paragraph"
            },
            {
              "data":{
      
              },
              "content":[
                {
                  "data":{
      
                  },
                  "marks":[
      
                  ],
                  "value":"",
                  "nodeType":"text"
                }
              ],
              "nodeType":"paragraph"
            },
            {
              "data":{
      
              },
              "content":[
                {
                  "data":{
      
                  },
                  "marks":[
      
                  ],
                  "value":"Please have your invoice available. You will need information on it to make a payment through our ",
                  "nodeType":"text"
                },
                {
                  "data":{
                    "uri":"/invoice/pay"
                  },
                  "content":[
                    {
                      "data":{
      
                      },
                      "marks":[
      
                      ],
                      "value":"Payments Portal",
                      "nodeType":"text"
                    }
                  ],
                  "nodeType":"hyperlink"
                },
                {
                  "data":{
      
                  },
                  "marks":[
      
                  ],
                  "value":"",
                  "nodeType":"text"
                }
              ],
              "nodeType":"paragraph"
            }
          ],
          "nodeType":"document"
        },
        invoicePayTextBodyLower:{
          "nodeType":"document",
          "data":{
      
          },
          "content":[
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"Bank Wire Transfer\n",
                  "marks":[
                    {
                      "type":"bold"
                    }
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"Financial institution:",
                  "marks":[
                    {
                      "type":"bold"
                    }
                  ],
                  "data":{
      
                  }
                },
                {
                  "nodeType":"text",
                  "value":" Bank of America ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"\n",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                },
                {
                  "nodeType":"text",
                  "value":"Account name: ",
                  "marks":[
                    {
                      "type":"bold"
                    }
                  ],
                  "data":{
      
                  }
                },
                {
                  "nodeType":"text",
                  "value":"Moderna US, Inc.  ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"\n",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                },
                {
                  "nodeType":"text",
                  "value":"ACH/Wire routing number:",
                  "marks":[
                    {
                      "type":"bold"
                    }
                  ],
                  "data":{
      
                  }
                },
                {
                  "nodeType":"text",
                  "value":" 011000138/02009593 ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"\n",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                },
                {
                  "nodeType":"text",
                  "value":"Account number:",
                  "marks":[
                    {
                      "type":"bold"
                    }
                  ],
                  "data":{
      
                  }
                },
                {
                  "nodeType":"text",
                  "value":" 466001423356 ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"Please include your invoice number as the reference when initiating the transfer.",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":" ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                },
                {
                  "nodeType":"text",
                  "value":"Check ",
                  "marks":[
                    {
                      "type":"bold"
                    }
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"",
                  "marks":[
                    {
                      "type":"bold"
                    }
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"Note: Currently, payment by check is only available to customers whose invoice total is below $5,000.  \n \nMake checks payable to Moderna and send them to: ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"\nLockbox Address: ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"Moderna US, Inc.  ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"P.O. Box 411543 ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"Boston, MA 02241-1543 ",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"Please be advised that the available payment options are subject to change and may be updated as necessary.",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            },
            {
              "nodeType":"paragraph",
              "data":{
      
              },
              "content":[
                {
                  "nodeType":"text",
                  "value":"If you encounter any difficulties with payment processing or have further questions, our dedicated customer support team is here to assist you at 1-866-MODERNA (1-866-663-3762) between the hours of 8:00AM- 8:00PM EST, Monday-Friday (not including Holidays). You can also email wecare@modernatx.com with questions.",
                  "marks":[
      
                  ],
                  "data":{
      
                  }
                }
              ]
            }
          ]
        },
        title:"InvoicePay ",
        invoiceBanner:{
          "metadata":{
            "tags":[
      
            ],
            "concepts":[
      
            ]
          },
          "sys":{
            "space":{
              "sys":{
                "type":"Link",
                "linkType":"Space",
                "id":"n9bebhw263o0"
              }
            },
            "id":"1Px4l8fvDKjBGrRTCqfWrE",
            "type":"Asset",
            "createdAt":"2022-12-29T16:44:45.722Z",
            "updatedAt":"2022-12-29T16:44:45.722Z",
            "environment":{
              "sys":{
                "id":"master",
                "type":"Link",
                "linkType":"Environment"
              }
            },
            "publishedVersion":5,
            "revision":1,
            "locale":"en-US"
          },
          "fields":{
            "title":"Banner BG strand top right",
            "description":"Banner BG strand top right",
            "file":{
              "url":bannerStrandRight,
              "details":{
                "size":47693,
                "image":{
                  "width":1920,
                  "height":511
                }
              },
              "fileName":"Banner_BG_strand_right.png",
              "contentType":"image/png"
            }
          }
        },
        pageTitle:"Moderna payment options",
        invoicePayButtonText:"Pay by credit card or ACH bank transfer"
}
